module.exports = __webpack_public_path__ + "static/calefaccion-3fb4f568e9b7bcf6d5c60a31c747e332.jpg";